import { render, staticRenderFns } from "./file-thumbnail.app.vue?vue&type=template&id=71effc31&"
import script from "./file-thumbnail.app.vue?vue&type=script&lang=js&"
export * from "./file-thumbnail.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports